<template>
  <section
    class="section section-primary is-small animated preFadeInUp fadeInUp"
  >
    <div class="container">
      <div class="columns is-vcentered">
        <div class="column is-6 is-offset-3 mb-90">
          <!-- Login form -->
          <div class="flex-card raised padding-20">
            <div class="square-icon-box rounded danger mt-20">
              <div class="icon-box-wrapper">
                <div class="icon-box">
                  <i class="material-icons">close</i>
                </div>
              </div>
            </div>
            <div class="animated preFadeInLeft fadeInLeft pb-90">
              <hr />

              <h1 class="subtitle is-5">عذراً، هذه الخدمة موقوفة مؤقتاً</h1>

              <hr />
            </div>
          </div>
          <div
            class="hero-foot has-text-centered mt-20 mb-20 animated preFadeInUp fadeInUp"
          >
            <a
              class="button is-dark btn-align modal-dismiss is-bold is-medium"
              @click="$router.go('-1')"
            >
              <b>العودة للرئيسية</b>
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "closed",

  data() {
    return {};
  },
  methods: {},
};
</script>
